import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { formatDate } from '@/lib/format';

export const PLAN_LABEL = { none: 'Sin plan', basic: 'Básico', pro: 'PRO' };

export const COMMERCIAL_MSG = {
  not_approved: 'Tu cuenta está pendiente de aprobación de documentos. Aún no puedes vender.',
  plan_required: 'Selecciona una modalidad (Sin plan, Básico o PRO) para empezar a vender.',
  plan_expired: 'Tu modalidad venció. Selecciona o renueva una modalidad para seguir vendiendo.',
};

const daysLeft = (iso) => Math.ceil((new Date(iso) - new Date()) / 86400000);

export const SellerModalityCard = ({ commercial }) => {
  if (!commercial) return null;
  const { plan, benefit, can_sell: canSell, permanent_pro: permanent } = commercial;
  const tone = canSell ? 'border-emerald-500 bg-emerald-50' : 'border-red-500 bg-red-50';
  return (
    <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="seller-modality-card">
      <div className={`border-2 ${tone} p-5`}>
        <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-slate-500">Modalidad</div>
        <div className="mt-1 font-display text-xl font-black text-slate-900" data-testid="seller-modality-status">
          {plan?.plan ? PLAN_LABEL[plan.plan] : 'Sin modalidad'} · {canSell ? 'Vigente' : (plan?.expired ? 'Vencida' : 'Pendiente')}
        </div>
        <p className="mt-3 text-sm text-slate-700" data-testid="seller-modality-detail">
          {permanent ? 'PRO permanente sin costo (excepción otorgada por administración).'
            : plan?.expires_at ? `${plan.expired ? 'Venció' : 'Vence'} el ${formatDate(plan.expires_at)}`
            : COMMERCIAL_MSG[commercial.reason]}
        </p>
        {!canSell && !permanent && commercial.reason !== 'not_approved' && (
          <Link to="/vendedor/suscripcion" className="inline-block mt-3">
            <Button size="sm" className="rounded-none bg-slate-900 hover:bg-slate-800" data-testid="seller-modality-select-btn">
              Elegir modalidad
            </Button>
          </Link>
        )}
      </div>
      {benefit?.granted && (
        <div className={`border-2 p-5 ${benefit.active ? 'border-orange-500 bg-orange-50' : 'border-slate-200 bg-white'}`} data-testid="seller-benefit-card">
          <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-orange-700">Beneficio de lanzamiento</div>
          <div className="mt-1 font-display text-xl font-black text-slate-900">
            {benefit.active ? `Activo · ${daysLeft(benefit.expires_at)} días restantes` : 'Finalizado'}
          </div>
          <p className="mt-3 text-sm text-slate-700" data-testid="seller-benefit-detail">
            Cupo #{benefit.slot} · del {formatDate(benefit.starts_at)} al {formatDate(benefit.expires_at)} · modalidad sin costo y comisión del {benefit.commission_pct}%.
          </p>
        </div>
      )}
    </div>
  );
};
